// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__NRekR","modalForm":"UpgradeEpcsModal_modalForm__2CbXC","modalFooter":"UpgradeEpcsModal_modalFooter__serBi"};